import { PhoneNumberSchema } from "@redotech/redo-model/phone/phone-number";
import * as z from "zod/v4";

export const getTeamPhoneNumber = {
  name: "getTeamPhoneNumber" as const,
  input: z.object({}),
  output: PhoneNumberSchema.nullable(),
};
